import { render, staticRenderFns } from "./menutop.vue?vue&type=template&id=31d1491c&"
import script from "./menutop.vue?vue&type=script&lang=js&"
export * from "./menutop.vue?vue&type=script&lang=js&"
import style0 from "./menutop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports